<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">
        {{ $tc("cinema", 1) }} {{ $t("tickettemplates") }}
      </div>
      <router-link
        v-if="$can('create', 'Cinema Ticket Templates')"
        class="btn-blue"
        to="add-cinema-ticket-templates"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div v-if="TemplateList.length > 0" class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'cine_name'"
                @click="onSortValue('cine_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('cine_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('cine_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("cinema", 1) }} {{ $t("tickettemplates") }}
            </th>
          </tr>
        </thead>
        <tbody v-if="TemplateList.length > 0">
          <tr
            v-for="(tickettemp, tickettempIndex) in TemplateList"
            :key="tickettempIndex"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    tickettemp.tt_is_active === 'Y'
                      ? 'active'
                      : tickettemp.tt_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Cinema Ticket Templates')"
                    v-on:click="onTicketTemp('Edit', tickettemp.tt_id)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item> -->
            <!-- to="view-ticket-templates -->
            <!-- <b-dropdown-item
                    v-on:click="onTicketTemp('View', tickettemp.tt_id)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    tickettemp.tt_is_active === 'Y' ? 'active' : 'inactive'
                  "
                />
                <div
                  v-if="$can('update', 'Cinema Ticket Templates')"
                  class="ml-4 clickable-icon"
                  @click="onTicketTemp('Edit', tickettemp.tt_id)"
                  style="cursor: pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </div>
                <div
                  class="ml-2 clickable-icon"
                  @click="onTicketTemp('View', tickettemp.tt_id)"
                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </div>
              </div>
            </td>
            <td>{{ tickettemp.cine_name }} ({{ tickettemp.t_name }})</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="2">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="TemplateList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  computed: {
    CLIENT_SETUP_NAME() {
      return this.$store.getters.CLIENT_SETUP_NAME;
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      TemplateList: [],
      cinema_id: null,

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    this.getCinemaTicketTemplateList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCinemaTicketTemplateList();
      } else {
        this.currentPage = event;
        this.getCinemaTicketTemplateList();
      }
    },

    onTicketTemp: function (type, id) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-cinema-ticket-templates",
          query: { tt_id: id },
        });
      } else {
        this.$router.push({
          path: "/master/view-cinema-ticket-templates",
          query: { tt_id: id },
        });
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCinemaTicketTemplateList();
    },

    getCinemaTicketTemplateList: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.cinema_id,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      console.log("body :", body);
      MasterService.GetCinemaTicketTemplate(body).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTicketTemplates/CinematicketTemplates.vue